import {
  Component,
  Input,
} from '@angular/core';

import { getInitialsFromNameData } from '../user/user-helpers';


@Component({
  moduleId: module.id,
  selector: 'user-avatar',
  templateUrl: 'user-avatar.component.html',
  styleUrls: ['user-avatar.component.scss']
})
export class UserAvatarComponent {

  @Input() color: string = 'black';
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() avatar: string;

  // getters
  get initials() {
    if (this.firstName && this.lastName) {
      return getInitialsFromNameData(this.firstName, this.lastName);
    }
    return null;
  }
}
